<ion-icon name="help-circle-outline" class="help-icon superscript" [ngClass]="{'small-help': small}" title="Click to learn more"
    (click)="showHelp($event)"></ion-icon>